import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../Modal";
import "./style.scss";

const LocationRequiredModal = ({ status, failed, onRequest }) => {
	const { t } = useTranslation("main");

	const isOpen =
		status === "prompt" || status === "locating" || status === "blocked";
	const isDenied = status === "blocked";
	const isLoading = status === "locating";

	return (
		<Modal isOpen={isOpen} toggle={() => {}} closeIcon={false} backdrop="static" size={400}>
			<div className="modal-body location-required-modal">
				<div className="location-required-modal__title">
					{t("Требуется доступ к геолокации")}
				</div>
				<div className="location-required-modal__text">
					{isDenied
						? t(
								"Вы запретили доступ к геолокации. Разрешите его в настройках сайта в браузере и нажмите «Повторить».",
							)
						: t(
								"Для работы в системе необходимо разрешить доступ к геолокации. Нажмите «Разрешить доступ» и подтвердите запрос браузера вверху экрана.",
							)}
				</div>
				{!isDenied && failed && (
					<div className="location-required-modal__hint">
						{t(
							"Не удалось определить местоположение. Проверьте, включена ли служба геолокации в настройках вашего устройства, и попробуйте снова.",
						)}
					</div>
				)}
				<button
					type="button"
					onClick={onRequest}
					disabled={isLoading}
					className={`d-btn d-btn-primary d-btn--full ${
						isLoading ? "--loading" : ""
					}`}
				>
					{isDenied ? t("Повторить") : t("Разрешить доступ")}
				</button>
			</div>
		</Modal>
	);
};

export default LocationRequiredModal;
